import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export async function initI18nBackend(
  endpoint: string = 'http://localhost:3002',
) {
  const backendOptions = {
    loadPath: `${endpoint}/locales/{{lng}}/translation.json`,
    crossDomain: true,
    requestOptions: {
      mode: 'no-cors',
      credentials: 'include',
    },
  };

  return i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: 'en', // if you're using a language detector, do not define the lng option
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
      backend: backendOptions,
    });
}

export async function initI18nLocale(translations: { en: any }) {
  return i18n.use(initReactI18next).init({
    resources: { en: { translation: translations.en } },
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
}
